export default __webpack_public_path__ + "assets/images/1f6b7f2df5d6b74ba61dd991e1c46fdd.svg";